import { EMPTY_STRING } from '@tekion/tekion-base/app.constants';
export const TODO_LIST_MODAL_TITLE = __('My To do');
export const TODO_OBJECT = {
  checked: false,
  item: EMPTY_STRING
};
export const TODO_ACTIONS = {
  TODO_ADD: 'todo_add',
  TODO_UPDATE: 'todo_update',
  TODO_DELETE: 'todo_delete'
};